<login-home-navigation></login-home-navigation>

<!-- HERO -->

<section class="faq-hero">

    <div class="container">

        <span class="faq-badge">
            Help Center
        </span>

        <h1>
            Frequently Asked Questions
        </h1>

        <p>
            Everything buyers and suppliers need to know about sourcing,
            RFQs, supplier discovery and manufacturing partnerships.
        </p>

    </div>

</section>

<!-- FAQ -->

<section class="faq-section">

    <div class="container">

        <div class="faq-category">

            <h2>General Questions</h2>

            <div class="accordion" id="faqAccordion">

                <div class="card">
                    <div class="accordion-header" data-toggle="collapse" data-target="#faq1">
                        What is Get Your Vendor (GYV)?
                    </div>
                    <div class="collapse show" id="faq1" data-parent="#faqAccordion">
                        <div class="accordion-body">
                            Get Your Vendor is a manufacturing supplier discovery platform that connects buyers with verified suppliers across machining, casting, forging, fabrication, plastic molding and custom manufacturing categories.
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="accordion-header" data-toggle="collapse" data-target="#faq2">
                        Who can use GYV?
                    </div>
                    <div class="collapse" id="faq2" data-parent="#faqAccordion">
                        <div class="accordion-body">
                            Procurement teams, OEMs, sourcing managers, manufacturing companies, MSMEs, contract manufacturers and industrial suppliers can use the platform.
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="faq-category">

            <h2>For Buyers</h2>

            <div class="card">
                <div class="accordion-header" data-toggle="collapse" data-target="#faq3">
                    How can buyers find suppliers on GYV?
                </div>
                <div class="collapse" id="faq3">
                    <div class="accordion-body">
                        Buyers can search suppliers by process, capability, location, certifications and manufacturing category.
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="accordion-header" data-toggle="collapse" data-target="#faq4">
                    Can buyers submit RFQs?
                </div>
                <div class="collapse" id="faq4">
                    <div class="accordion-body">
                        Yes. Buyers can submit RFQs and receive quotations from relevant suppliers.
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="accordion-header" data-toggle="collapse" data-target="#faq5">
                    How do buyers verify suppliers?
                </div>
                <div class="collapse" id="faq5">
                    <div class="accordion-body">
                        Buyers can evaluate supplier profiles, manufacturing capabilities, certifications, infrastructure and industry experience.
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="accordion-header" data-toggle="collapse" data-target="#faq6">
                    Which industries use GYV?
                </div>
                <div class="collapse" id="faq6">
                    <div class="accordion-body">
                        Automotive, Aerospace, Defence, Railways, Engineering, Oil & Gas, Electronics, Electrical, Medical Devices and Industrial Equipment sectors.
                    </div>
                </div>
            </div>

        </div>

        <div class="faq-category">

            <h2>For Suppliers</h2>

            <div class="card">
                <div class="accordion-header" data-toggle="collapse" data-target="#faq7">
                    Who can register as a supplier?
                </div>
                <div class="collapse" id="faq7">
                    <div class="accordion-body">
                        Any manufacturing company, job shop, contract manufacturer or industrial service provider can register.
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="accordion-header" data-toggle="collapse" data-target="#faq8">
                    How do suppliers receive business opportunities?
                </div>
                <div class="collapse" id="faq8">
                    <div class="accordion-body">
                        Suppliers receive relevant RFQs and buyer inquiries based on their capabilities and selected categories.
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="accordion-header" data-toggle="collapse" data-target="#faq9">
                    How often are new RFQs added?
                </div>
                <div class="collapse" id="faq9">
                    <div class="accordion-body">
                        New sourcing opportunities are added regularly as buyers submit manufacturing requirements.
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="accordion-header" data-toggle="collapse" data-target="#faq10">
                    Can multiple users be added under one company?
                </div>
                <div class="collapse" id="faq10">
                    <div class="accordion-body">
                        Yes. Depending on the subscription package, multiple team members can access the same company account.
                    </div>
                </div>
            </div>

        </div>

        <div class="faq-category">

            <h2>Platform & Security</h2>

            <div class="card">
                <div class="accordion-header" data-toggle="collapse" data-target="#faq11">
                    Is my company data secure?
                </div>
                <div class="collapse" id="faq11">
                    <div class="accordion-body">
                        Yes. Company profiles, quotations and uploaded documents are protected through secure access controls.
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="accordion-header" data-toggle="collapse" data-target="#faq12">
                    How do I get started?
                </div>
                <div class="collapse" id="faq12">
                    <div class="accordion-body">
                        Create your account, complete your company profile and start connecting with buyers or suppliers immediately.
                    </div>
                </div>
            </div>

        </div>

    </div>

</section>

<!-- CTA -->

<section class="faq-cta">

    <div class="container">

        <h2>
            Ready To Grow Your Manufacturing Network?
        </h2>

        <p>
            Join thousands of buyers and suppliers already using GYV to discover new business opportunities.
        </p>

        <div class="cta-buttons">

            <a routerLink="/buyersbenefits" class="btn-primary">
                Find Suppliers
            </a>

            <a routerLink="/vendorsbenefits" class="btn-secondary">
                Join As Supplier
            </a>

        </div>

    </div>

</section>

<login-home-footer></login-home-footer>